import { __module as reactIs } from "./auth-service-tools455.js";
import { __require as requireReactIs_production_min } from "./auth-service-tools456.js";
import { __require as requireReactIs_development } from "./auth-service-tools457.js";

if (process.env.NODE_ENV === "production") {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;
export { reactIsExports as r };